'use strict';

function shouldProcessEveryNode(node) {
    return true;
}

module.exports = {
    shouldProcessEveryNode: shouldProcessEveryNode
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/html-to-react/lib/should-process-node-definitions.js
 ** module id = 533
 ** module chunks = 0
 **/